import { FC, InputHTMLAttributes, ReactNode } from 'react';

import {
    FakeRadioButton,
    FakeRadioDot,
    HelperText,
    RadioButtonContainer,
    RadioButtonInput,
    RadioButtonLabel,
    RadioButtonLabelText,
} from './RadioButton.styles';

export type RadioButtonProps = {
    name: string;
    value: string;
    label: ReactNode;
    checked?: boolean;
    defaultChecked?: boolean;
    disabled?: boolean;
    helperText?: ReactNode;
    fullWidth?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export const RadioButton: FC<RadioButtonProps> = ({
    name,
    value,
    disabled,
    label,
    checked,
    defaultChecked,
    helperText,
    className,
    fullWidth,
    ...htmlInputProps
}) => {
    return (
        <RadioButtonContainer className={className} $fullWidth={!!fullWidth}>
            <RadioButtonLabel>
                <RadioButtonInput
                    {...htmlInputProps}
                    name={name}
                    value={value}
                    disabled={disabled}
                    defaultChecked={defaultChecked}
                    checked={checked}
                />

                <FakeRadioButton>
                    <FakeRadioDot />
                </FakeRadioButton>

                <RadioButtonLabelText>{label}</RadioButtonLabelText>
            </RadioButtonLabel>

            {!!helperText && <HelperText>{helperText}</HelperText>}
        </RadioButtonContainer>
    );
};
